<template>
    <div class="dx-field">
        <div class="dx-field-label">Договорной контекст</div>
        <!-- Поле ввода с кнопкой -->
        <DxTextBox
            :value="selectedDepartment"
            cssClass="texbox-dictonary"
            :element-attr="{ class: 'class-name' }"
            :read-only="true"
            :buttons="buttonsOptions"
        />

        <!-- Всплывающее окно с деревом -->
        <DxPopup
            ref="popupRef"
            v-model:visible="popupVisible"
            :close-on-outside-click="true"
            :drag-enabled="false"
            height="95%"
            :hide-on-outside-click="true"
            :show-close-button="true"
            :show-title="true"
            :title="title"
        >
            <DxTreeView
                :data-source="treeDataSource"
                key-expr="id"
                display-expr="name"
                items-expr="items"
                has-items-expr="hasItems"
                @item-selection-changed="handleSelect"
                @item-expanding="handleItemExpanding"
            />

            <dx-toolbar-item location="after" toolbar="bottom">
                <dx-button text="Выбрать" @click="chooseItem" />
            </dx-toolbar-item>

            <dx-toolbar-item location="after" toolbar="bottom">
                <dx-button text="Отмена" @click="hide" />
            </dx-toolbar-item>
        </DxPopup>
    </div>
</template>

<script setup>
import { ref, reactive } from 'vue';

import { DxTextBox, DxButton, DxToolbarItem, DxPopup, DxTreeView } from 'devextreme-vue';

// --- Состояние ---
const popupVisible = ref(false);
const selectedDepartment = ref('');
const treeDataSource = ref([{ id: 'root', name: 'Организация', hasItems: true }]);

const buttonsOptions = reactive([
    {
        name: 'clearButton',
        options: {
            visible: true,
            disabled: false,
            icon: 'close',
            onClick: async () => {},
        },
    },

    {
        name: 'editButton',
        options: {
            icon: `<svg  width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path  d="M100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50Z" fill="#286EB6"/>
<path  d="M32.0012 50.0002C32.0012 53.314 29.3149 56.0002 26.0012 56.0002C22.6875 56.0002 20.0012 53.314 20.0012 50.0002C20.0012 46.6865 22.6875 44.0002 26.0012 44.0002C29.3149 44.0002 32.0012 46.6865 32.0012 50.0002Z" fill="white"/>
<path  d="M55.999 49.999C55.999 53.3127 53.3127 55.999 49.999 55.999C46.6853 55.999 43.999 53.3127 43.999 49.999C43.999 46.6853 46.6853 43.999 49.999 43.999C53.3127 43.999 55.999 46.6853 55.999 49.999Z" fill="white"/>
<path  d="M80.0005 49.999C80.0005 53.3127 77.3142 55.999 74.0005 55.999C70.6868 55.999 68.0005 53.3127 68.0005 49.999C68.0005 46.6853 70.6868 43.999 74.0005 43.999C77.3142 43.999 80.0005 46.6853 80.0005 49.999Z" fill="white"/>
</svg>
`,
            disabled: false,
            onClick: () => {
                popupVisible.value = true;
            },
        },
    },
]);

// --- Функция подгрузки дочерних узлов ---
const loadChildren = node => {
    return new Promise(resolve => {
        setTimeout(() => {
            if (node.id === 'root') {
                resolve([
                    { id: 'it', name: 'IT-отдел', hasItems: true },
                    { id: 'finance', name: 'Финансовый отдел', hasItems: true },
                ]);
            } else if (node.id === 'it') {
                resolve([
                    { id: 'dev', name: 'Разработка' },
                    { id: 'support', name: 'Техподдержка' },
                ]);
            } else if (node.id === 'finance') {
                resolve([
                    { id: 'accounting', name: 'Бухгалтерия' },
                    { id: 'audit', name: 'Аудит' },
                ]);
            } else {
                resolve([]);
            }
        }, 500); // Симуляция задержки API
    });
};

// --- Обработчик раскрытия узла ---
const handleItemExpanding = async e => {
    const node = e.itemData;

    // Если узел ещё не загружен
    if (!node.items && node.hasItems) {
        const children = await loadChildren(node);
        node.items = children;

        // Обновляем dataSource
        treeDataSource.value = [...treeDataSource.value]; // Триггер реактивности
    }
};

// --- Обработчик выбора узла ---
const handleSelect = e => {
    if (e.itemData && !e.itemData.hasItems) {
        selectedDepartment.value = e.itemData.name;
        popupVisible.value = false;
    }
};

const chooseItem = () => {
    popupVisible.value = false;
};

const hide = () => {
    popupVisible.value = false;
};
</script>

<style lang="scss" scoped>
.class-name {
    :deep(.dx-texteditor-input) {
        color: black !important;
    }
}

.class-name {
    :deep(.dx-texteditor-container) {
        background-color: #f5f5f5;
    }
}

.ai-dx-invalid::after {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 40%;
    margin-top: -11px;
    text-align: center;
    line-height: 23px;
    font-size: 14px;
    font-weight: 500;
    background-color: #ffffff00;
    color: #fff;
    content: '!';
    border-radius: 50%;
}

.ai-dx-invalid {
    cursor: pointer;
    position: absolute;
    top: 65%;
    right: 60px;
    margin-top: -11px;
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 23px;
    font-size: 14px;
    font-weight: 500;
    background-color: #f44336;
    color: #fff;
    content: '!';
    border-radius: 50%;
}
</style>
